import {
  SiReactrouter,
  SiGithub,
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiReact,
  SiExpress,
  SiNodedotjs,
  SiMongodb,
  SiPostman,
  SiSass,
  SiFigma,
  SiBootstrap,
  SiMaterialui,
  SiGreensock,
  SiFramer,
} from "react-icons/si";
import { FaGithub, FaLinkedinIn, FaTwitter, FaCodepen } from "react-icons/fa";

const myName = [
  { contentP: ["hi,", "I'm"] },
  { contentH: ["Murad", "Muqbel"] },
  { tagline: ["I'm a fullstack web developer"] },
];

const greeting = ["Hello", "Ola", "مرحبا", "Bonjour", "Ciao", "Hallo"];

const links = [
  { about: "about" },
  { projects: "projects" },
  { contact: "contact" },
];

const socialLinks = [
  {
    platform: "Github",
    logo: <FaGithub />,
    link: "https://github.com/muradgm",
  },
  {
    platform: "Linkedin",
    logo: <FaLinkedinIn />,
    link: "https://www.linkedin.com/in/murad-muqbel-b88b38232/",
  },
  {
    platform: "Twitter",
    logo: <FaTwitter />,
    link: "https://twitter.com/MuradZee",
  },
  {
    platform: "Codepen",
    logo: <FaCodepen />,
    link: "https://codepen.io/muradgm",
  },
];

const skills = [
  {
    skill: "HTML",
    icon: <SiHtml5 />,
  },
  {
    skill: "CSS",
    icon: <SiCss3 />,
  },
  {
    skill: "JavaScript",
    icon: <SiJavascript />,
  },
  {
    skill: "React",
    icon: <SiReact />,
  },
  {
    skill: "Express",
    icon: <SiExpress />,
  },
  {
    skill: "Nodejs",
    icon: <SiNodedotjs />,
  },
  {
    skill: "MongoDB",
    icon: <SiMongodb />,
  },
  {
    skill: "Postman",
    icon: <SiPostman />,
  },
  {
    skill: "Github",
    icon: <SiGithub />,
  },
  {
    skill: "Sass",
    icon: <SiSass />,
  },
  {
    skill: "Figma",
    icon: <SiFigma />,
  },
  {
    skill: "Bootstrap",
    icon: <SiBootstrap />,
  },
  {
    skill: "Material UI",
    icon: <SiMaterialui />,
  },
  {
    skill: "GSAP",
    icon: <SiGreensock />,
  },
  {
    skill: "Framer Motion",
    icon: <SiFramer />,
  },
];

const projects = [
  {
    id: 1,
    title: "Loka",
    description:
      "This Project is our Final Project of the one year fullstack web developer course at DCI Digital Career Institute gGmbH.",
    builtWith: [
      <SiReact />,
      <SiSass />,
      <SiJavascript />,
      <SiGreensock />,
      <SiReactrouter />,
      <SiExpress />,
      // <SiMaterialui />,
    ],
    repo: "https://github.com/muradgm/LOKA",
    url: "https://loka.vercel.app/",
    src: require("../assets/images/lka-final.gif"),
  },
  {
    id: 2,
    title: "Ideas Come Together",
    description:
      "Ideas come together was my first Team project for our SPA module, ICT is an app to help users document their ideation process and share it with other users.",
    builtWith: [
      <SiReact />,
      <SiSass />,
      <SiJavascript />,
      <SiFramer />,
      <SiReactrouter />,
    ],
    repo: "https://github.com/muradgm/SPA-Final-Project",
    url: "https://ideas-come-together.vercel.app/",
    src: require("../assets/images/ICT.gif"),
  },
  {
    id: 3,
    title: "Guns N' Roses Blog",
    description:
      "A mini Fullstack exercise, the first exercise to work with both the front-end and the back-end. the task was to fetch POST, GET, UPDATE and DELETE requests to individual posts.",
    builtWith: [
      <SiReact />,
      <SiSass />,
      <SiJavascript />,
      <SiFramer />,
      <SiReactrouter />,
    ],
    repo: "https://github.com/muradgm/Guns-N-Roses",
    url: "https://muradgm.github.io/guns-n-roses/",
    src: require("../assets/images/gnsNroses.gif"),
  },
  {
    id: 4,
    title: "Message Board",
    description:
      "A mini Fullstack exercise, the first exercise to work with both the front-end and the back-end. the task was to fetch POST, GET, UPDATE and DELETE requests to individual posts.",
    builtWith: [
      <SiReact />,
      <SiJavascript />,
      <SiSass />,
      <SiBootstrap />,
      <SiExpress />,
    ],
    repo: "https://github.com/muradgm/Messageboard",
    url: "https://muradgm.github.io/Messageboard/",
    src: require("../assets/images/Messageboard.gif"),
  },
  {
    id: 5,
    title: "Login Overlay",
    description:
      "A small exercise on React Hooks. the task was to build a Login/Register components, and toggle between them. also part of the exercise was to use validators.",
    builtWith: [<SiReact />, <SiJavascript />, <SiSass />],
    repo: "https://github.com/muradgm/login-overlay",
    url: "https://muradgm.github.io/login-overlay",
    src: require("../assets/images/login-overlay.gif"),
  },
  {
    id: 6,
    title: "Random Card Generator",
    description:
      "My first React encounter, in this exercise we were asked to build a simple React app with some random data.",
    builtWith: [<SiReact />, <SiJavascript />, <SiSass />],
    repo: "https://github.com/muradgm/random-card-generator",
    url: "https://muradgm.github.io/random-card-generator/",
    src: require("../assets/images/random-card.gif"),
  },
  {
    id: 7,
    title: "MP3 Player",
    description:
      "This was a personal project i built. the app has very basic functionality including Play, Pause, Shuffle and Skip forward and backwards.",
    builtWith: [<SiHtml5 />, <SiCss3 />, <SiJavascript />],
    repo: "https://github.com/muradgm/MP3-Player",
    url: "https://muradgm.github.io/MP3-Player/main.html",
    src: require("../assets/images/mp3-player.gif"),
  },
  {
    id: 8,
    title: "007 Blog",
    description:
      "This was one of the early projects I undertook in the program. we were asked to build a mini website to show case our progress, the topic i chose was a mini James Bond movies blog.",
    builtWith: [<SiHtml5 />, <SiCss3 />],
    repo: "https://github.com/muradgm/007-Blog-Project",
    url: "https://muradgm.github.io/007-Blog-Project/",
    src: require("../assets/images/007.gif"),
  },
  {
    id: 9,
    title: "Fetchy Clicker",
    description:
      "Another mini exercise using React and API fetching. my task was to create an application that searches for GitHub repositories, using  at least 3 different components: Search, SearchResult, Spinner",
    builtWith: [<SiReact />, <SiJavascript />, <SiSass />],
    repo: "https://github.com/muradgm/fetchy-clicker",
    url: "https://muradgm.github.io/fetchy-clicker/",
    src: require("../assets/images/fetchy-click.gif"),
  },
];

export { myName, links, socialLinks, skills, projects, greeting };
